<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>{{ data.employeeSchedule == null ? data.sysText.addWorkSchedule_header : data.sysText.editWorkSchedule_header }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      (click)="cancel()"
      [attr.aria-label]="data.isAnonymousCase ? data.sysText.close : data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

@if (!data.isAnonymousCase) {
  <mat-dialog-content>
    <form [formGroup]="form">
      <app-date-field
        [label]="data.sysText.workSchedule_effectiveDate"
        [control]="form.controls.effectiveDate"
        [icon]="'calendar_today'"
        [group]="form"
        [hint]="data.sysText.workSchedule_effectiveDateHint"
        [isHintHighlighted]="false"
        [info]="data.sysText.workSchedule_effectiveDate_Info">
      </app-date-field>
      <div class="section-container	">
        <div class="label">
          <mat-icon>schedule</mat-icon>
          <p class="grey1">{{ data.sysText.employeeSchedule_schedule }}</p>
          <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
          <button
            type="button"
            class="button-reset info-button"
            [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
            [matTooltip]="data.sysText.employeeSchedule_schedule_info"
            [matTooltipShowDelay]="500"
            matTooltipPosition="above">
            <mat-icon class="button-icon">info_outline</mat-icon>
          </button>
        </div>
        <div class="fields">
          <app-select-field
            [control]="form.controls.employerWorkScheduleId"
            [label]="data.sysText.workSchedule_title"
            [options]="data.dialogData.workScheduleOptions"
            [showBlankOption]="true"
            [hideIconSpace]="true"
            [shouldCapitalize]="false">
          </app-select-field>
          <div class="toggle-container">
            <app-slide-toggle
              [control]="this.form.controls.isIrregular"
              [label]="'Irregular Work Schedule'">
            </app-slide-toggle>
          </div>
        </div>
        <!-- Irregular Schedule settings -->
        <div class="section-container">
          <div class="label">
            <mat-icon>event</mat-icon>
            <p class="grey1">{{ data.sysText.workSchedule_repWorkSchedule | titlecase }}</p>
            <button
              type="button"
              class="button-reset info-button"
              [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
              [matTooltip]="data.sysText.workSchedule_repWorkSchedule_info"
              [matTooltipShowDelay]="500"
              matTooltipPosition="above">
              <mat-icon class="button-icon">info_outline</mat-icon>
            </button>
          </div>
          <app-input-field
            [control]="form.controls.averageWeeklyHours"
            [label]="data.sysText.employeeSchedule_averageWeeklyHours"
            [removeLabelCasePipe]="true"
            [inputType]="'number'">
          </app-input-field>
          <app-input-field
            [control]="form.controls.averageWeeklyWorkdays"
            [label]="data.sysText.employeeSchedule_averageWeeklyWorkdays"
            [removeLabelCasePipe]="true"
            [inputType]="'number'">
          </app-input-field>
          <app-select-field
            [control]="form.controls.startOfWorkweek"
            [label]="data.sysText.workSchedule_startOfWorkweek"
            [options]="dayOfWeekOptions"
            [showBlankOption]="true"
            [info]="data.sysText.workSchedule_startOfWorkweek_info"
            [shouldCapitalize]="false">
          </app-select-field>
        </div>
      </div>
      <div class="section-container">
        <div class="label">
          <mat-icon>event</mat-icon>
          <p
            id="non-workdays-label"
            class="grey1">
            {{ data.sysText.workSchedule_nonWorkdays | titlecase }}
          </p>
          <button
            type="button"
            class="button-reset info-button"
            [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
            [matTooltip]="data.sysText.employeeSchedule_nonWorkdays_info"
            [matTooltipShowDelay]="500"
            matTooltipPosition="above">
            <mat-icon class="button-icon">info_outline</mat-icon>
          </button>
        </div>
        <div class="select-container">
          <mat-selection-list
            [formControl]="form.controls.nonWorkdays"
            aria-labelledby="non-workdays-label">
            @for (nonWorkday of data.dialogData.nonWorkdayOptions; track nonWorkday.id) {
              <mat-list-option
                class="restore-condition"
                [disabled]="scheduleNonWorkdays?.nonWorkdays.includes(+nonWorkday.id)"
                [value]="nonWorkday.id">
                {{ nonWorkday.description }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      </div>
    </form>
  </mat-dialog-content>
} @else {
  <mat-dialog-content class="form-container">
    <p class="disallow">{{ data.sysText.workSchedule_anonymousMessage }}</p>
  </mat-dialog-content>
}


<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.isAnonymousCase ? data.sysText.close : data.sysText.cancel }}
    </button>
  }
  @if (!data.isAnonymousCase) {
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit()">
      {{ data.sysText.save }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  }
</mat-dialog-actions>
